var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","text-transform":"none"}},[_vm._v(_vm._s(_vm.logged_in_user))])}
var staticRenderFns = []

export { render, staticRenderFns }